import React from 'react';
import { GroupPeople } from './GroupPeople';
import { ErrorBoundary } from 'components';
import classnames from 'classnames';
import styles from './GroupSidebar.module.scss';

interface GroupSidebarProps {
  className?: string;
}

export const GroupSidebar: React.FC<GroupSidebarProps> = ({className}) => {
  return (
    <ErrorBoundary>
      <div className={classnames(className, styles.appsColumn, styles.container)}>
        <GroupPeople />
      </div>
    </ErrorBoundary>
  );
};
